import { TradeNameInterface } from '../Settings/TradeNameInterface';
import { InvoicerInterface } from '../Draft/DraftInterface';

export const TradeNameStub: TradeNameInterface = {
  name: '',
  contact: {
    name: {
      first: '',
      full: '',
      last: ''
    }
  },
  address: {
    streetAddress1: '',
    streetAddress2: '',
    city: '',
    zipCode: ''
  },
  default: true
};

export const InvoicerStub: InvoicerInterface = {
  tradeName: TradeNameStub,
  vatNumber: '',
  id: 0
};
